import { navLinks } from '@/mocks/drama';

export default function Footer() {
  return (
    <footer className="bg-primary-950 pt-16 pb-8">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,1fr)]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-foreground-950">
                继
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">
                  继母的诱惑
                </span>
                <span className="mt-0.5 text-[11px] font-label tracking-[0.2em] text-primary-200">
                  剧情解析
                </span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-100">
              一个围绕《继母的诱惑》短剧与小说展开的剧情解析页面，整理完整版脉络、未删减细节、人物关系与同类伦理题材作品推荐，帮助你快速理解故事走向。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              页面导航
            </h3>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="cursor-pointer text-sm font-label text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              本站内容
            </h3>
            <ul className="mt-4 space-y-3 text-sm font-label text-primary-100">
              <li>完整版剧情脉络解析</li>
              <li>未删减细节差异说明</li>
              <li>人物关系与立场梳理</li>
              <li>同类作品方向推荐</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 继母的诱惑 · 剧情解析站</p>
          <p>本页内容为剧情层面的解析与整理，仅供观剧参考。</p>
        </div>
      </div>
    </footer>
  );
}